import { id, Identifiable, calendarHolidays, Resource } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getResourceCalendarHolidays({ uuid }: Identifiable<Resource>) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.calendarHolidays : { ...calendarHolidays };
    },
    isRetrieveResourceCalendarHolidaysRequestFailure({
      uuid,
    }: Identifiable<Resource>) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRetrieveResourceCalendarHolidaysRequestPending({
      uuid,
    }: Identifiable<Resource>) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRetrieveResourceCalendarHolidaysRequestSuccess({
      uuid,
    }: Identifiable<Resource>) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
